import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
//import { formatCurrency } from "./helpers/commons";
import moment from "moment";

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
	lng: 'pt',
	fallbackLng: 'pt',
    debug: true,
    //supportedLngs : ['pt', 'en'],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      format: function(value, format, lng) {
          if (format === 'uppercase') return value.toUpperCase();
          if (format === 'replacenull' && !value) return "-";
          if (value instanceof Date) return moment(value).format(format);
          return value;
      }
    },
  });

export default i18n;
